import * as types from '@/store/mutation-types'
import axios from 'axios'
import Vue from 'vue'

const state = {
  listaEstados: JSON.parse(localStorage.getItem('listaEstados')) || [],
  status: ''
}

const mutations = {
  [types.FETCH_CATALOGO_ESTADOS]: (state) => {
    state.status = 'loading'
  },
  [types.FETCH_CATALOGO_ESTADOS_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'listaEstados', resp)
  },
  [types.FETCH_CATALOGO_ESTADOS_FAILURE]: (state) => {
    state.status = 'error'
  }
}

const actions = {
  [types.FETCH_CATALOGO_ESTADOS]: ({commit, distpatch}) => {
    commit(types.FETCH_CATALOGO_ESTADOS)
    axios.get('catalogo/estados')
      .then(resp => {
        commit(types.FETCH_CATALOGO_ESTADOS_SUCCESS, resp.data.estados)
        localStorage.setItem('listaEstados', JSON.stringify(resp.data.estados))
      })
      .catch(err => {
        console.log(err)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/catalogs.js